import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const DeleteNewsAndEventsSlice = createSlice({
    name: "deleteNewsAndEventsRequest",
    initialState,
    reducers: {
        deleteNewsAndEventsRequest(state) {
            state.loading = true;
        },
        deleteNewsAndEventsRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        deleteNewsAndEventsRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        deleteNewsAndEventsStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    deleteNewsAndEventsRequest,
    deleteNewsAndEventsRequestSuccess,
    deleteNewsAndEventsRequestError,
    deleteNewsAndEventsStateReset,
} = DeleteNewsAndEventsSlice.actions;

export default DeleteNewsAndEventsSlice.reducer;
